import React from 'react';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES, setAppLanguage, AppLanguage } from '../i18n';

interface Props {
  className?: string;
  onChange?: (lang: AppLanguage) => void;
}

const LanguageSwitcher: React.FC<Props> = ({ className = '', onChange }) => {
  const { i18n, t } = useTranslation();
  const current = (i18n.language || 'en').slice(0, 2) as AppLanguage;

  return (
    <select
      aria-label={t('nav.language')}
      value={current}
      onChange={(e) => {
        const lang = e.target.value as AppLanguage;
        setAppLanguage(lang);
        onChange?.(lang);
      }}
      className={`rounded-md border border-gray-300 bg-white text-sm text-gray-700 px-2 py-1.5 min-h-[36px] focus:outline-none focus:ring-2 focus:ring-blue-500 ${className}`}
    >
      {SUPPORTED_LANGUAGES.map((lang) => (
        <option key={lang} value={lang}>
          {t(`language.${lang}`)}
        </option>
      ))}
    </select>
  );
};

export default LanguageSwitcher;
